










































































import { PatientExerciseTypes } from '@/jsonapi/PatientExercise'

type ComponentData = {
  exerciseIsValid: boolean
  exercise: {
    exerciseName: string
    type: string
    id: string
    reps: number | null
    sets: number | null
    equipment: number | null
    resistance: number | null
    timeMin: number | null
  }
  equipmentOptions: { name: string; value: string }[]
  [key: string]: any
}

const cardioProps = ['id', 'type', 'exerciseName', 'timeMin']
const strengthProps = ['id', 'type', 'exerciseName', 'reps', 'sets', 'equipment', 'resistance']

export default {
  props: {
    patientExercise: {
      type: Object,
      required: true,
    },
  },

  data(): ComponentData {
    return {
      exerciseIsValid: false,
      exercise: {
        exerciseName: '',
        type: '',
        id: '',
        reps: null,
        sets: null,
        equipment: null,
        resistance: null,
        timeMin: null,
      },
      equipmentOptions: [
        { name: 'Weight', value: 'Weight' },
        { name: 'Band', value: 'Band' },
        { name: 'None', value: 'None' },
      ],
      exerciseNameRules: [v => !!v || 'Exercise Name is required'],
    }
  },

  computed: {
    isStrengthExercise() {
      return this.patientExercise.type === PatientExerciseTypes.Strength
    },
    isCardioExercise() {
      return this.patientExercise.type === PatientExerciseTypes.Cardio
    },
    exerciseTypeIcon() {
      return this.isStrengthExercise ? 'mdi-dumbbell' : 'mdi-run'
    },
  },

  watch: {
    exercise: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('updatePatientExercise', newVal)
      },
    },
    exerciseIsValid: {
      immediate: true,
      handler(newVal, oldVal) {
        this.$emit('validatePatientExercise', {
          id: this.exercise.id,
          isValid: newVal,
        })
      },
    },
  },

  mounted() {
    const props = this.isStrengthExercise ? strengthProps : cardioProps
    props.forEach(prop => {
      this.exercise[prop] = this.patientExercise[prop]
    })
  },

  methods: {
    deleteExerciseAction() {
      this.$emit('deletePatientExercise', this.exercise)
    },
  },
}
